import { RawFile } from './file-types';
import path from 'path-browserify';

export class FileTemplate implements RawFile {
	isFile: boolean = true;
	source?: string;
	name: string;
	path: string;
	relativePath: string;

	constructor(fileName: string, content: string = '') {
		this.source = content;
		this.name = path.basename(fileName);
		this.path = fileName;
		this.relativePath = fileName
	}

	toObj() {
		return {
			isFile: this.isFile,
			name: this.name,
			source: this.source,
			path: this.path,
			relativePath: this.relativePath,
		};
	}
}

export function mutateFilepath(file: RawFile, filepath: string){
	if(file.path === filepath) return file;
	
	return {
		...file,
		name: path.basename(filepath),
		path: filepath,
		relativePath: filepath,
	}
}